import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const Button = ({
  id,
  value,
  text,
  type,
  form,
  disabled,
  onClick,
  inProgress,
  isChecked,
  className,
}) => {
  return (
    <button
      id={id}
      value={value}
      type={type}
      form={form}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {text}
      {inProgress && <FontAwesomeIcon icon={faSpinner} spin></FontAwesomeIcon>}
      {isChecked && (
        <FontAwesomeIcon
          className="float-right mt-1 mr-1 text-green-500"
          icon={faCheckCircle}
        ></FontAwesomeIcon>
      )}
    </button>
  );
};

export default Button;
